import { BookingStatus } from "../enums/BookingScope";

const sportMappings: Record<string, string> = {
  Padel: "Padel",
  Tennis: "Tennis",
  Football: "Calcio",
  Basketball: "Basket",
  Pickleball: "Pickleball",
  Volley: "Pallavolo",
  BeachTennis: "Beach Tennis",
  BeachVolley: "Beach Volley",
  Badminton: "Badminton",
};

const tournamentTypeMapping: Record<string, string> = {
  Men: "Maschile",
  Women: "Femminile",
  Mixed: "Misto"
}

const bookingTypeMapping: Record<string, string> = {
  Friendly: "Amichevole",
  Tournament: "Torneo",
  Training: "Lezione",
};

export const getSportName = (sport: string): string => {
  return sportMappings[sport] || "Sconosciuto";
};

export const getTournamentType = (type: string): string => {
  return tournamentTypeMapping[type] || "Sconosciuto";
};

export function isPastDateTime(day: string, hour: string): boolean {
  // Concateniamo la data e l'ora e creiamo un oggetto Date
  const inputDateTime = new Date(`${day}T${hour}:00.000`);
  const now = new Date();

  return inputDateTime < now;
}

export const getBookingType = (type: string): string => {
  return bookingTypeMapping[type] || "Sconosciuto";
};

/** Etichetta del tipo: la tipologia personalizzata del gestore, se c'è. */
export const getBookingTypeLabel = (booking: {
  bookingType?: string;
  customType?: string | null;
}): string => booking.customType || getBookingType(booking.bookingType || "");

export const getStatusLabel = (status: BookingStatus) => {
  switch (status) {
    case BookingStatus.Pending:
      return "In Corso";
    case BookingStatus.Cancelled:
      return "Cancellata";
    case BookingStatus.Completed:
      return "Completata";
  }
};

export const getMimeType = (fileName: string): string => {
  const extension = fileName.split(".").pop()?.toLowerCase();

  const mimeTypes: Record<string, string> = {
    jpg: "image/jpeg",
    jpeg: "image/jpeg",
    png: "image/png",
    gif: "image/gif",
    webp: "image/webp",
    svg: "image/svg+xml",
    pdf: "application/pdf",
    txt: "text/plain",
    csv: "text/csv",
    json: "application/json",
    xml: "application/xml",
    zip: "application/zip",
    mp4: "video/mp4",
    mp3: "audio/mpeg",
  };

  return mimeTypes[extension || ""] || "application/octet-stream";
};

export function formatDate(dateString: string): string {
  const date = new Date(dateString);
  const day = String(date.getUTCDate()).padStart(2, "0");
  const month = String(date.getUTCMonth() + 1).padStart(2, "0");
  const year = date.getUTCFullYear();
  return `${day}/${month}/${year}`;
}